import { startHTTPRequest } from "../../../assets/js/common";
import { CFG_NODE_API_BASE/* , SPORT_LIST */ } from '../../../assets/js/config';

const setFirstPage = (state, routeParams) => {
    let pageFromUrl = routeParams.page_number;
    if (pageFromUrl && !isNaN(pageFromUrl) && (+pageFromUrl > state.pagenumber)) {
        state.firstPage = +pageFromUrl;
        state.pagenumber = +pageFromUrl;
    } else {
        state.firstPage = 1;
    }

    /* if (routeParams.sport_name) {
        let sport = SPORT_LIST.find(s => s.name.toLocaleLowerCase() === routeParams.sport_name.toLocaleLowerCase())
        if(sport && sport.id) {
            state.selected_sport = sport.id;
        } else {
            state.selected_sport = 1;
        }
    } */
}

const schedule = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.schedule) ? window.__ROI_STATE_DATA__.schedule : {
        store_schedule_filled: false,
        contests_updated: false,
        module: null,
        pagenumber: 1,
        itemnumber: 21, // this is the item count for page!=1
        pagesize: 21, // this is the item count for page==1
        totalCount: 0,
        selected_sport: 1,
        seriesList: [],
        show_loader: true,
        isLoadMoreDisabled: false,
        no_matches_active: false,
        sportList: [1, 2],
        current_sport: null,
        sportDetails: {
            "1": {
                hasMatches: false,
                name: "Cricket",
                className: "sports-cricket"
            },
            "2": {
                hasMatches: false,
                name: "Football",
                className: "sports-football"
            }
        }
    }),
    actions: {
        fetchSeriesListing: ({ state, rootState }) => {
            if (state.isLoadMoreDisabled) return;
            state.isLoadMoreDisabled = true;
            let { route } = rootState;
            if (!state.firstPage) {
                route.params && setFirstPage(state, route.params);
            }
            let actionData = {
                method: "GET",
                url: `${CFG_NODE_API_BASE}series/get-series-list-v2`,
                params: {
                    sport_id: state.selected_sport,
                    pgnum: state.pagenumber,
                    items: state.itemnumber,
                    pg1items: state.pagesize
                },
                can_append: false
            };
            return startHTTPRequest(actionData)
                .then((res) => {
                    let { list, series_count } = (res || {});
                    state.totalCount = (series_count || 0);
                    state.seriesList = list;
                    state.store_schedule_filled = true;
                    state.show_loader = false;
                    state.isLoadMoreDisabled = false;
                })
                .catch((err) => {
                    console.log(err);
                    state.totalCount = 0;
                    state.seriesList = [];
                    state.store_schedule_filled = true;
                    state.show_loader = false;
                    state.isLoadMoreDisabled = false;
                })
        }
    }
}
export default schedule;
